'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FocusProvider = function (_React$Component) {
  _inherits(FocusProvider, _React$Component);

  function FocusProvider(props) {
    _classCallCheck(this, FocusProvider);

    var _this = _possibleConstructorReturn(this, (FocusProvider.__proto__ || Object.getPrototypeOf(FocusProvider)).call(this, props));

    _this.state = {
      focused: false
    };
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }

  _createClass(FocusProvider, [{
    key: 'handleFocus',
    value: function handleFocus(evt) {
      (0, _Functions.callIfPossible)(this.props.onFocus, evt);
      if (this.state.focused !== true) this.setState({ focused: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(evt) {
      (0, _Functions.callIfPossible)(this.props.onBlur, evt);
      if (this.state.focused !== false) this.setState({ focused: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          focusedProp = _props.focused;
      var focused = this.state.focused;

      return children({
        focused: focusedProp != null ? focusedProp : focused,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      });
    }
  }]);

  return FocusProvider;
}(_react2.default.Component);

FocusProvider.displayName = 'FocusProvider';

exports.default = FocusProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/providers/FocusProvider.js
// module id = 573
// module chunks = 171